import React, { Component } from 'react';
import { Button } from 'primereact/button';

class CartPanel extends Component {

    render() {
        const {
            cartItems,
            kotItems,
            onUpdateQty,
            onRemoveFromCart,
            onSendToKitchen,
            sendingToKitchen,
            onSave,
            onFinish,
            grandTotal,
            actions,          // ← new: optional array of { label, onClick, className }
            hideKotSection,   // ← new: optional bool
            printKOT,         // ← new: optional function to print KOT
            isBillGenerated,   // ← new: true if a bill already exists for this order/request
            onGoToBill,        // ← new: navigate to the existing bill/billing view
        } = this.props;

        const cartTotal = cartItems.reduce((sum, item) => sum + (item.qty * item.price), 0);

        return (
            <div className="pos-cart-panel">

                {/* ---- TOP: pending items, not yet sent to kitchen ---- */}
                <div className="pos-cart-pending">
                    <div className="pos-cart-scroll">
                        <table className="pos-cart-table">
                            <thead>
                                <tr>
                                    <th className="col-name">Item Name</th>
                                    <th className="col-price">Price</th>
                                    <th className="col-qty">Qty</th>
                                    <th className="col-total">Total</th>
                                    <th className="col-action"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {cartItems.map(item => (
                                    <tr key={item.id}>
                                        <td className="col-name">
                                            {item.name}
                                            {item.modifiersLabel && (
                                                <span className="pos-cart-item-modifiers">{item.modifiersLabel}</span>
                                            )}
                                        </td>
                                        <td className="col-price">{item.price.toFixed(2)}</td>
                                        <td className="col-qty">
                                            <div className="pos-qty-controls">
                                               <Button
                                                icon="pi pi-minus"
                                                className="p-button-text p-button-xsm pos-qty-btn-minus"
                                                onClick={() => onUpdateQty(item.id, -1)}
                                            />
                                            <span className="pos-qty-value">{item.qty}</span>
                                            <Button
                                                icon="pi pi-plus"
                                                className="p-button-text p-button-xsm pos-qty-btn-plus"
                                                onClick={() => onUpdateQty(item.id, 1)}
                                            />
                                            </div>
                                        </td>
                                        <td className="col-total">{(item.qty * item.price).toFixed(2)}</td>
                                        {/* <td className="col-action">
                                            <Button
                                                icon="pi pi-trash"
                                                className="p-button-text p-button-danger p-button-xsm"
                                                onClick={() => onRemoveFromCart(item.id)}
                                            />
                                        </td> */}
                                    </tr>
                                ))}
                                {cartItems.length === 0 && (
                                    <tr><td colSpan="5" className="pos-empty-row">No items added yet</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="pos-cart-total pos-cart-total-sticky">
                        CART TOTAL : {cartTotal.toFixed(2)}
                    </div>
                    {/* {cartItems.length > 0 && (
                    <div className="pos-cart-actions pos-cart-actions-sticky">
                        <Button
                            icon="pi pi-save"
                            label="Save"
                            className="p-button-outlined pos-cart-action-btn"
                            onClick={() => onSave('save')}
                        />
                        <Button
                            label="Save & Send Kitchen (/)"
                            className="p-button-primary pos-cart-action-btn pos-cart-action-btn-wide"
                            onClick={onSendToKitchen}
                        />
                            <Button
                                label="Save & Print KOT (&)"
                                className="p-button-primary pos-cart-action-btn pos-cart-action-btn-wide"
                                onClick={onSendToKitchen}
                            />
                        <Button
                            label="Print Bill & Finish (*)"
                            className="p-button-success pos-cart-action-btn"
                            onClick={onSendToKitchen}
                        />
                    </div>
                    )} */}
                    {/* Hidden once the bill exists — same flag that turns
                        Generate Bill into Go to Bill below. */}
                    {cartItems.length > 0 && !isBillGenerated && (
                        <div className="pos-cart-actions pos-cart-actions-sticky">
                            {actions ? (
                                actions.map((a, i) => (
                                    <Button
                                        key={i}
                                        label={a.label}
                                        className={a.className || 'p-button-primary pos-cart-action-btn'}
                                        onClick={a.onClick}
                                    />
                                ))
                            ) : (
                                <>
                                    <Button icon="pi pi-save" label="Save" className="p-button-outlined pos-cart-action-btn" onClick={() => onSave('save')} disabled={sendingToKitchen} />
                                    <Button label="Save & Send Kitchen (/)" className="p-button-primary pos-cart-action-btn pos-cart-action-btn-wide" onClick={onSendToKitchen} disabled={sendingToKitchen} />
                                    <Button label="Save & Print KOT (&)" className="p-button-primary pos-cart-action-btn pos-cart-action-btn-wide" onClick={onSendToKitchen} disabled={sendingToKitchen} />
                                    <Button label="Print Bill & Finish (*)" className="p-button-success pos-cart-action-btn" onClick={onSendToKitchen} disabled={sendingToKitchen} />
                                </>
                            )}
                        </div>
                    )}

                </div>

                {/* ---- BOTTOM: items already sent to kitchen, waiting for bill ---- */}
                {!hideKotSection && (
                <div className="pos-cart-kot">
                    <h4>Sent to Kitchen</h4>
                    <div className="pos-cart-scroll">
                        <table className="pos-cart-table">
                            <thead>
                                <tr>
                                    <th className="col-index">#</th>
                                    <th className="col-name">Item Name</th>
                                    <th className="col-price">Price</th>
                                    <th className="col-qty-sm">Qty</th>
                                    <th className="col-total">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {kotItems.map((item, idx) => (
                                    <tr key={item.id}>
                                        <td className="col-index">{idx + 1}</td>
                                        <td className="col-name">
                                            {item.name}
                                            {item.modifiersLabel && (
                                                <span className="pos-cart-item-modifiers">{item.modifiersLabel}</span>
                                            )}
                                        </td>
                                        <td className="col-price">{item.price.toFixed(2)}</td>
                                        <td className="col-qty-sm">{item.qty}</td>
                                        <td className="col-total">{item.total.toFixed(2)}</td>
                                    </tr>
                                ))}
                                {kotItems.length === 0 && (
                                    <tr><td colSpan="5" className="pos-empty-row">Nothing sent to kitchen yet</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="pos-cart-total pos-cart-total-sticky">
                        ORDER TOTAL : {grandTotal.toFixed(2)}
                    </div>

                    <div className="pos-cart-actions pos-cart-actions-sticky">
                        <Button label="Split" icon="pi pi-th-large" className="p-button-outlined pos-cart-action-btn" />
                        <Button label="Shift" icon="pi pi-arrow-right" className="p-button-outlined pos-cart-action-btn" />
                        <Button label="Merge Order" icon="pi pi-arrows-h" className="p-button-outlined pos-cart-action-btn" />
                        <Button label="KOT" icon="pi pi-print" className="p-button-outlined pos-cart-action-btn" onClick={printKOT} />
                        {/* <Button
                            label="Generate Bill(*)"
                            icon="pi pi-check"
                            className="p-button-success pos-cart-action-btn"
                            onClick={onFinish}
                        /> */}
                        {isBillGenerated ? (
                            <Button
                                label="Go to Bill"
                                icon="pi pi-arrow-right"
                                className="p-button-success pos-cart-action-btn"
                                onClick={onGoToBill}
                                disabled={sendingToKitchen}
                            />
                        ) : (
                            // Disabled while any save is in flight, like the cart buttons
                            // above: pressed then, the bill save was only queued behind it.
                            <Button
                                label="Generate Bill(*)"
                                icon="pi pi-check"
                                className="p-button-success pos-cart-action-btn"
                                onClick={onFinish}
                                disabled={sendingToKitchen}
                            />
                        )}
                    </div>
                </div>
                )}
            </div>
        );
    }
}

export default CartPanel;
